import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 0.7rem;
  width: 100%;
  position: relative;
`;

export const Avatar = styled.div<{ $avatarSrc: string }>`
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-image: url(${({ $avatarSrc }) => $avatarSrc});
  background-size: cover;
  background-position: center;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;

  > h1 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 0.9rem;
    color: #323232;
  }

  > span {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.75rem;
    color: #8c8c8c;
  }

  > p {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.9rem;
    color: #323232;
    margin-top: 0.2rem;
    /* Comentário longo sem espaços não pode esticar o card do post. */
    overflow-wrap: anywhere;
  }
`;

/** "editado" ao lado do texto — discreto, mas nunca escondido. */
export const EditedMark = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.7rem;
  color: #8c8c8c;
  margin-left: 0.3rem;
`;

export const Actions = styled.div`
  display: flex;
  gap: 0.6rem;
  margin-top: 0.35rem;
`;

const actionButton = css`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: 'RedHatDisplay-Medium';
  font-size: 0.75rem;
  transition: color 0.15s ease;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const ActionButton = styled.button`
  ${actionButton}
  color: #8c8c8c;

  &:hover:not(:disabled) {
    color: #1e88e5;
  }
`;

export const DangerButton = styled.button`
  ${actionButton}
  color: #8c8c8c;

  &:hover:not(:disabled) {
    color: #e53935;
  }
`;

/**
 * Confirmação inline em vez de window.confirm.
 *
 * O diálogo nativo trava a aba inteira e não combina com o resto da interface
 * — e aqui o que está em jogo cabe numa linha.
 */
export const ConfirmRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.35rem;

  > span {
    font-family: 'RedHatDisplay-Medium';
    font-size: 0.75rem;
    color: #e53935;
  }
`;

export const EditForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.3rem;

  > textarea {
    width: 100%;
    min-height: 3.4rem;
    resize: vertical;
    padding: 0.5rem 0.6rem;
    border: 1px solid #d9d9d9;
    border-radius: 0.5rem;
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.9rem;
    color: #323232;

    &:focus {
      outline: none;
      border-color: #1e88e5;
    }
  }
`;

export const ErrorText = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.75rem;
  color: #e53935;
  margin-top: 0.25rem;
`;
